import * as Sentry from "@sentry/react"

function parseSampleRate(raw: string | null | undefined, fallback: number): number {
  if (raw == null || raw === "") return fallback
  const n = Number(raw)
  return Number.isFinite(n) ? Math.min(1, Math.max(0, n)) : fallback
}

export function initSentry(): void {
  if (typeof document === "undefined") return

  const reportInDev =
    document.querySelector('meta[name="sentry-report-in-development"]')?.getAttribute("content") === "1"
  if (!import.meta.env.PROD && !reportInDev) return

  const dsn = document.querySelector('meta[name="sentry-dsn"]')?.getAttribute("content")?.trim()
  if (!dsn) return

  const environment =
    document.querySelector('meta[name="sentry-environment"]')?.getAttribute("content")?.trim() ||
    import.meta.env.MODE

  const tracesSampleRate = parseSampleRate(
    document.querySelector('meta[name="sentry-traces-sample-rate"]')?.getAttribute("content"),
    0.1,
  )


  Sentry.init({
    dsn,
    environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate,
  })
}

export const captureClientException = Sentry.captureException
